import blueLogo from "@/assets/transportmate-logo-blue-transparent.png";
import { SupportModeBadge } from "@/components/support/SupportModeBadge";
import { NotificationBell } from "@/components/NotificationBell";
import { useNavigate } from "react-router-dom";
import { Search } from "lucide-react";
import { openCommandBar } from "@/lib/commandBarBus";

export function DesktopAdminHeader() {
  const navigate = useNavigate();

  return (
    <header className="flex h-16 shrink-0 items-center border-b border-border bg-card px-5">
      {/* Logo */}
      <button
        onClick={() => navigate("/dashboard")}
        className="flex min-h-11 items-center gap-2 border-0 bg-transparent focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2"
        aria-label="Go to dashboard"
      >
        <img
          src={blueLogo}
          alt="TransportMate"
          className="h-8 w-auto object-contain"
          onError={(e) => {
            e.currentTarget.style.display = "none";
          }}
        />
      </button>

      <SupportModeBadge className="ml-4" />

      {/* Spacer */}
      <div className="flex-1" />

      {/* Right actions */}
      <div className="flex items-center gap-3">
        <button
          type="button"
          onClick={openCommandBar}
          className="flex h-9 items-center gap-2 rounded-lg border border-border bg-background px-3 text-sm text-muted-foreground transition-colors hover:bg-accent hover:text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
          aria-label="Open command bar (Ctrl+K)"
        >
          <Search className="h-4 w-4" />
          <span className="hidden lg:inline">Search</span>
          <kbd className="hidden rounded border border-border bg-muted px-1.5 py-0.5 font-mono text-[10px] lg:inline">
            ⌘K
          </kbd>
        </button>
        <div className="text-foreground">
          <NotificationBell />
        </div>
      </div>
    </header>
  );
}
